export { default as CoreDialogContentWrapper } from './Content';
export { default as CoreDialogPromptWrapper } from './Prompt';
